/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Col, Row, Typography } from 'antd';
import { useState } from 'react';
import { Button } from '@/components/button';
import { PlusOutlined } from '@ant-design/icons';
import ComboFoodManagementTable from '@/components/tables/combo-food-management/combo-food-management.table';
import { PageURLs } from '@/utils/navigate';
import { useQuery } from '@/hooks/query.hook';
import { PermissionMode } from '@/enums/mode.enum';
import {
  resetHealthNutritionProfiles
} from '@/redux/slices/combo-food.slice';
import { useAppDispatch } from '@/redux/hooks';
import usePermission from '@/hooks/permission.hook';
export default function ProductManagement() {
  const { creatable, importable } = usePermission();
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState('TABLE');
  const { push } = useQuery();

  const onAdd = async () => {
    await dispatch(resetHealthNutritionProfiles());
    push(`${PageURLs.ofComboFoodManagement()}?mode=${PermissionMode.CREATE}`);
  }

  const onGroup = () => {
    setActiveTab('IMPORT_BY_LIST');
    push(`${PageURLs.ofComboFoodManagement()}?mode=${PermissionMode.GROUP}`);
  }
  return (
    <div css={rootStyles}>
      {!['IMPORT', 'IMPORT_BY_LIST'].includes(activeTab) && (
        <>
          <Row css={boxStyles} justify="space-between" align="middle">
            <Col>
              <Typography.Title css={titleStyles} level={5}>
                Quản lý combo thực phẩm
              </Typography.Title>
            </Col>
            <Col>
              <Row justify="space-between" css={{ gap: '10px' }}>
                {creatable && (
                  <Button
                    icon={<PlusOutlined />}
                    iconPosition="start"
                    onClick={onAdd}
                    css={selfInputButtonStyles}
                  >
                    Tự xây dựng thực đơn chi tiết
                  </Button>
                )}
                {importable && (
                  <Button
                    onClick={onGroup}
                    css={listInputButtonStyles}
                  >
                    Nhập thực đơn chi tiết theo danh sách
                  </Button>
                )}

              </Row>
            </Col>
          </Row>
        </>
      )}

      <div css={contentStyles}>
        {activeTab === 'TABLE' && <ComboFoodManagementTable />}
      </div>
    </div>
  );
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const contentStyles = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;

const selfInputButtonStyles = css`
  color: var(--blue-light-color);
  border-color: var(--blue-light-color);

  &:hover {
    background-color: var(--white-color) !important;
    color: var(--blue-light-color) !important;
    border-color: var(--blue-light-color) !important;
  }
`;

const listInputButtonStyles = css`
  background-color: var(--success-color);
  color: var(--white-color);
  border-color: var(--success-color);

  &:hover {
    background-color: var(--success-color) !important;
    border-color: var(--success-color) !important;
  }
`;